/* eslint-disable @typescript-eslint/no-explicit-any */
import { IOssixProvider } from 'interfaces/otherInterface/dynamicInput';
import {
  ActionType,
  DestType,
  GatewayType,
  TargetType,
  TransferSourceType,
} from 'types/generalType';

interface TransferToMNOParm {
  provider?: IOssixProvider;
  inputFormValue?: any;
  country?: string;
  accountNumber?: string;
  amount?: string;
  accountNumberName?: string;
  pin?: string;
  sendFundsToGateway?: any;
  destinationCountry?: string;
  targetAccountNumber?: string;
  targetUrl?: string;
  targetPhoneNumber?: string;
  userPhoneNumber?: string;
  sourceWallet?: string;
  formValues?: any;
  otherKeys?: any;
  description?: string;
}

export const MNOTransferConfirmation = ({
  provider,
  inputFormValue,
  country,
  accountNumber,
  amount,
  accountNumberName,
  targetPhoneNumber,
  userPhoneNumber,
  formValues,
  otherKeys,
  description,
}: TransferToMNOParm) => {
  const {
    inputField,
    phoneNumber,
    firstName,
    lastName,
    ...restFormValues
  } = inputFormValue;

  const { Amount, type, verifyAccount, verifyURL, ...restForm } =
    formValues;

  return {
    saveBeneficiaryPayload: {
      CountryCode: country,
      ActionType: provider?.ActionType || '',
      ShortName: provider?.ShortName,
      Category: provider?.Category,
      CustomerID: '',
      AccountNumber: inputFormValue?.serviceNumber || '',
      FirstName: firstName || accountNumberName || '',
      LastName: lastName || '',
      PhoneNumber: phoneNumber,
      ...restFormValues,
    },
    transferConfirmationPayload: {
      ActionType: provider?.ActionType,
      TargetType: TargetType.MNOGetaway,
      Category: provider?.Category,
      GatewayOperationType: GatewayType.MOBILE_TRANSFER,
      AccountNumber: accountNumber,
      SourceWallet: accountNumber,
      BrandUnikID: provider?.BrandUnikID,
      ShortName: provider?.ShortName,
      Amount: amount || '',
      DestType: DestType.OTHER,
      SourceType: TransferSourceType.BANK,
      TargetCountryCode: country,
      PartnerRequest: {
        reason: description || '',
        merchant: provider?.ShortName || provider?.OperatorName,
        phoneNumber:
          phoneNumber || targetPhoneNumber || userPhoneNumber,
        ...restFormValues,
        ...restForm,
      },
      otherKeys: { ...otherKeys },
    },
  };
};

export const MNOTransfer = ({
  pin,
  inputFormValue,
  sendFundsToGateway,
  provider,
  accountNumber,
  amount,
  destinationCountry,
  targetAccountNumber,
  targetPhoneNumber,
  targetUrl,
  userPhoneNumber,
  sourceWallet,
  formValues,
  otherKeys,
  description,
}: TransferToMNOParm) => {
  const {
    inputField,
    phoneNumber,
    firstName,
    lastName,
    ...restFormValues
  } = inputFormValue;

  const {
    Amount,
    type,
    verifyAccount,
    verifyURL,
    serviceNumber,
    amountType,
    ...restForm
  } = formValues;

  sendFundsToGateway({
    PIN: pin,
    DepositorName: '',
    TargetType: TargetType.MNOGetaway,
    GatewayOperationType: GatewayType.MOBILE_TRANSFER,
    Category: provider?.Category,
    ActionType: ActionType.Transfer,
    BrandUnikID: provider?.BrandUnikID,
    ShortName: provider?.ShortName,
    SourceWallet: sourceWallet,
    AccountNumber: accountNumber,
    Amount: amount,
    TargetCountryCode: destinationCountry,
    FirstName: firstName || '',
    LastName: lastName || '',
    OperatorID: provider?.OperatorID,
    OperatorName: provider?.OperatorName,
    SwiftCode: '',
    IBAN: '',
    billRef: '',
    DestType: DestType.OTHER,
    SourceType: TransferSourceType.BANK,
    TransferURL: targetUrl || '',
    TargetAccountNumber:
      targetAccountNumber ||
      restFormValues?.serviceNumber ||
      restFormValues?.accountNumber ||
      accountNumber ||
      phoneNumber ||
      userPhoneNumber,
    PartnerRequest: {
      reason: description || '',
      merchant: provider?.ShortName || provider?.OperatorName,
      phoneNumber: targetPhoneNumber || phoneNumber,
      ...restFormValues,
      ...restForm,
    },
    ...otherKeys,
  });
  return;
};
